/* eslint-disable no-unused-vars */
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './product-bundles.html';
import { MySiteApp, OverwritePaperRadioButtonStyles } from '../../my-site-app';
import { ProductStatusService, ProductService, ShopContextService } from '@nuskin/ns-shop';
import { ProductDataService } from '@nuskin/ns-product';
import { MySiteRestService } from '@nuskin/my-site-api';
import { SidebarMenu } from '@nuskin/my-site/src/my-site-app/sidebar-menu/sidebar-menu';
import { BundleUpdateCreate } from '@nuskin/my-site/src/my-site-app/forms/bundle-update-create/bundle-update-create';
import { UserService } from '@nuskin/ns-account';
import { TdcStrings, nuskin } from '@nuskin/ns-util';

/**
 * @customElement
 * @polymer
 */
export class ProductBundles extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);

        this.data = {} //api data
        this.bundles = [];

        // pass save method to form wrapper
        this.parentNode.saveForm = this.save();
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'product-bundles';
    }

    static get properties() {
        return {
            useDefaultList: {
                type: Boolean,
                observer: '_handleUseDefaultOption'
            },
            bundlesLoading: {
                type: Boolean,
                observer: '_handleBundleLoading'
            }
        }
    }

    connectedCallback() {
        super.connectedCallback();
        this.mySite = document.querySelector(MySiteApp.is);
        this.overwritePaperRadioButtonStyles();
        this.mySite.addEventListener('on-menu-item-click', this._handleFormShow.bind(this));
        this.mySite.addEventListener('my-site-data-changed', this.getMySiteData.bind(this));

        this.$.sortable.addEventListener('on-ns-sorted-list-reorder', this._handleOrderChange.bind(this));
        this.$.sortable.addEventListener('on-ns-sorted-item-removed', this._handleItemRemoved.bind(this));
        this.$.sortable.customActions = [
            {
                caption: this.content.bundlesFormEditBundle,
                icon: 'icon-edit',
                func: (e) => {
                    let clickedItem = this.findParentByClass(e.target, 'ns-sortable-item');
                    let bundleId = clickedItem.dataset.id;
                    let parent = document.querySelector(MySiteApp.is);
                    let sidebarMenu = parent.$.mySiteSidebarWrapper.querySelector(SidebarMenu.is);

                    let eventObj = {
                        currentTarget: {
                            dataset: {
                                action: BundleUpdateCreate.is,
                                additionalData: {
                                    bundleId,
                                    do: 'edit'
                                }
                            }
                        }
                    };

                    sidebarMenu.onMenuItemClick(eventObj);
                }
            }
        ]
    }

    _handleBundleLoading(newVal) {
        if (newVal) {

            this.timeout = this.timeout || setTimeout(() => {
                this.mySite.iframeLoading = true;
            }, 2000);

            this.$.defaultOption.setAttribute('disabled', true)
            this.$.customOption.setAttribute('disabled', true)
            this.$.createNewBundleBtn.setAttribute('disabled', true)
        } else {
            this.$.defaultOption.removeAttribute('disabled', true)
            this.$.customOption.removeAttribute('disabled', true)
            this.$.createNewBundleBtn.removeAttribute('disabled', true)

            clearTimeout(this.timeout);
            this.mySite.iframeLoading = false;
            this.timeout = null;
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback()
        this.mySite.removeEventListener('on-menu-item-click', this._handleFormShow.bind(this));
        this.mySite.removeEventListener('my-site-data-changed', this.getMySiteData.bind(this));


        this.$.sortable.addEventListener('on-ns-sorted-list-reorder', this._handleOrderChange.bind(this));
        this.$.sortable.addEventListener('on-ns-sorted-item-removed', this._handleItemRemoved.bind(this));
    }

    async _handleUseDefaultOption(newVal, oldVal) {

        this.$.defaultOption.checked = newVal;
        this.$.customOption.checked = !newVal;

        this.$.chooseDefault.className = newVal ? '' : 'hidden';
        this.$.chooseCustom.className = !newVal ? '' : 'hidden';

        if (!this.mySite) return;

        if (!newVal) {
            this.$.sortable.resizeItemsContainer();
            let bndls = this.mySite.mySiteData.storefront[this.subdomain][this.mySite.currentMarket].bundles;
            if (!bndls || !bndls.length) {
                let bundles = await MySiteRestService.getMarketFeaturedBundle(this.mySite.currentMarket);
                this.parentElement.updateAndNotify([{ id: 0, skus: bundles }], true, false, 'bundles', true);
            }
        } else { // pull products from AEM
            let bundles = await MySiteRestService.getMarketFeaturedBundle(this.mySite.currentMarket);
            this.parentElement.updateAndNotify([{ id: 0, skus: bundles }], true, false, 'bundles', true);
        }

        if (oldVal !== undefined) {
            this.parentElement.formTouched();
            this.parentElement.setFormValidity(true);
        }
    }

    overwritePaperRadioButtonStyles() {
        OverwritePaperRadioButtonStyles(this.$.defaultOption);
        OverwritePaperRadioButtonStyles(this.$.customOption);
    }

    _handleDefaultClick() {
        this.useDefaultList = true;
        this.$.defaultOption.checked = true;
        this.$.customOption.checked = false;
        this.parentNode.updateAndNotify(this.useDefaultList, true, false, 'showDefaultBundles', true);
    }

    _handleCustomClick() {
        this.useDefaultList = false;
        this.$.defaultOption.checked = false;
        this.$.customOption.checked = true;
        this.parentNode.updateAndNotify(this.useDefaultList, true, false, 'showDefaultBundles', true);
    }

    _handleOrderChange(e) {
        this.set('bundles', e.detail.reorderedList);

        this.parentNode.updateAndNotify(e.detail.reorderedList.map(item => ({
            id: item.id,
            skus: item.products.map(p => p.sku)
        })), true, false, 'bundles', true);
        this.parentElement.formTouched();
    }

    _handleItemRemoved(e) {
        let updatedList = this.bundles.slice();
        updatedList.splice(e.detail.index * 1, 1);
        this.set('bundles', updatedList);

        this.parentNode.updateAndNotify(updatedList.map(item => ({
            id: item.id,
            skus: item.products.map(p => p.sku)
        })), true, false, 'bundles', true);

        this.parentElement.formTouched();
    }

    _handleFormShow(e) {
        if (e.detail.item === ProductBundles.is) {
            this.$.sortable.resizeItemsContainer();
            // this.getMySiteData();
            this.parentElement.resetBackLocation();
        }
    }

    async getMySiteData() {
        if (this.mySite.currentForm !== ProductBundles.is) return;
        let bundles = [];
        this.set('data', this.mySite.mySiteData);
        this.set('subdomain', Object.keys(this.mySite.mySiteData.storefront)[0]);
        let bundlesData = this.getBundles() || [];
        let bundlesInfo = this.getBundlesInfo() || [];

        this.useDefaultList = !!this.data.storefront[this.subdomain][this.mySite.currentMarket].showDefaultBundles || false;

        this.set('bundlesLoading', true)

        if (bundlesData.length) {
            try {
                bundles = await this.getBundleProductObjects(bundlesData, bundlesInfo)
            } catch (error) {
                console.log({ context: "ProductBundles.getMySiteData", error: error });

            }
        }

        this.set('bundlesLoading', false)
        this.set('bundles', bundles);

        this.parentNode.formChanged();
    }

    async getBundleProductObjects(bundlesData, bundlesInfo) {
        let bundles = [];
        if (!this.mySite) return bundles;

        if (!bundlesData) {
            let bndl = await MySiteRestService.getMarketFeaturedBundle(this.mySite.currentMarket);
            bundlesData = [
                { id: 0, skus: bndl }
            ]
        }

        // get default from AEM
        if (!bundlesInfo) {
            let mySiteTranslationsTdc = await TdcStrings.getStrings('mysite/mysite-home', this.mySite.currentLanguage, this.mySite.currentMarket) || {};
            bundlesInfo = [
                {
                    bundle_id: 0,
                    name: mySiteTranslationsTdc.featuredBundleTitle,
                    about: mySiteTranslationsTdc.defaultBundlesMessage
                }
            ];
        }

        if (bundlesData.length) {
            for (let i = 0; i < bundlesData.length; i++) {
                let prodSvc;
                let products = [];
                if (!bundlesData[i].skus) continue;
                try {
                    prodSvc = await ProductDataService.getProductData(bundlesData[i].skus);

                    if (prodSvc && prodSvc.products) {

                        products = prodSvc.products
                            .map((product) => ({
                                sku: product.sku || bundlesData[i].skus,
                                itemName: product.title || 'Product not found',
                                priceMap: product.priceMap || {
                                    "WRTL": 0,
                                    "WADW-WRTL": 0,
                                    "WADR": 0,
                                    "RTL": 0,
                                    "WWHL": 0,
                                    "WADW": 0,
                                    "WHL": 0
                                },
                                psv: product.pv || 0,
                                img: (product.thumbnail && product.thumbnail.includes('https')) ? product.thumbnail : product.thumbnail ? nuskin.configuration.siteUrl + product.thumbnail : ''
                            }));
                    }

                } catch (err) {
                    console.log({ context: "ProductBundles.getBundleProductObjects", error: err });
                }

                const b = bundlesInfo.find(item => {
                    return item ? item.bundle_id === bundlesData[i].id : {}
                });

                bundles[i] = {
                    id: bundlesData[i].id,
                    name: b ? b.name : (this.mySite.mySiteHomeTranslations.tdc_featuredBundleTitle || ''),
                    products
                };
            }
        }

        return bundles;
    }

    _onCreateBundleClick() {
        let sidebarMenu = this.mySite.$.mySiteSidebarWrapper.querySelector(SidebarMenu.is);

        // if (this.parentElement.formWasUpdatedButNotSaved) {
        //   this.parentElement.customBackLocation = BundleUpdateCreate.is;
        //   this.parentElement.additionalData = {
        //     additionalData: {
        //       bundleId: new Date().getTime(),
        //       do: 'create'
        //     }
        //   }
        //   this.mySite.$.saveChangesModal.toggle();
        // } else {
        let eventObj = {
            currentTarget: {
                dataset: {
                    action: BundleUpdateCreate.is,
                    additionalData: {
                        bundleId: new Date().getTime(),
                        do: 'create'
                    }
                }
            }
        };

        sidebarMenu.onMenuItemClick(eventObj);
        // }
    }

    getBundles() {
        if (this.data.storefront) {
            let subdomain = Object.keys(this.data.storefront)[0];
            let bundles = this.data.storefront[subdomain][this.mySite.currentMarket].bundles || [];

            return bundles;
        }
    }

    getBundlesInfo() {
        if (this.data.storefront) {
            let subdomain = Object.keys(this.data.storefront)[0];

            return subdomain && this.mySite.currentMarket && this.mySite.currentLanguage
                ? (this.data.storefront[subdomain][this.mySite.currentMarket].lang[this.mySite.currentLanguage].bundlesInfo || [])
                : null
        }
    }

    findParentByClass(elem, className) {
        let found = false
        while (!found) {
            if ((elem.parentElement && elem.parentElement.className.indexOf(className) !== -1) || !elem.parentElement) {
                found = true;
                return elem.parentElement || {};
            }
            elem = elem.parentElement;

            if (!elem) {
                break;
            }
        }
    }

    save() {
        let that = this;
        return function () {
            let bundles = that.bundles.map(item => {
                return {
                    id: item.id,
                    skus: item.products.map(i => i.sku).filter(sku => sku)
                }
            });

            // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.SECTION_DATA_UPDATE, {
                    mySite: {
                        section: ProductBundles.is,
                        changed: bundles
                    }
                });
            } catch (err) { console.log(err) }

            return MySiteRestService.saveBundles(bundles, null, that.mySite.currentMarket, null, that.useDefaultList);
        }
    }

}

window.customElements.define(ProductBundles.is, ProductBundles);